module.exports = __webpack_public_path__ + "img/plus.d8159533.svg";